import { ISingleBinaryKeys } from "./GenerateSingleBinary";
import * as openpgp from "openpgp";
import { readFileFromBase64 } from "./readFileFromBase64";
import { readAsBase64 } from "./readAsBase64";

/**
 * Szyfruje klucz prywatny w formacie ISingleBinayKey
 * i zwraca w postaci base64
 * @param key klucz prywatny do zaszyfrowania
 * @param publicKey klucz publiczny, którym zostanie zaszyfrowany klucz prywatny
 * @returns zaszyfrowany klucz w base64
 */
const encryptPrivateKey = async (
  key: ISingleBinaryKeys,
  publicKey: openpgp.key.Key
): Promise<string> => {
  if (!key) {
    throw new Error("No key");
  }

  if (!key.PrivateKey && !key.cleanPrivateKey) {
    throw new Error("No private key");
  }

  // mamy klucz w postaci openPGP
  if (key.cleanPrivateKey) {
    const privateKeyData = new Uint8Array(
      key.cleanPrivateKey.keys[0].toPacketlist().write()
    );

    const { message } = await openpgp.encrypt({
      message: await openpgp.message.fromBinary(privateKeyData),
      publicKeys: [publicKey],
      armor: false,
    });

    const encryptedKeyData = await new Uint8Array(message.packets.write());

    return await readAsBase64(encryptedKeyData);
  } else {
    const privateKeyData = await readFileFromBase64(
      key.PrivateKey,
      "application/other"
    );

    const { message } = await openpgp.encrypt({
      message: await openpgp.message.fromBinary(privateKeyData),
      publicKeys: [publicKey],
      armor: false,
    });

    const encryptedKeyData = await new Uint8Array(message.packets.write());

    return await readAsBase64(encryptedKeyData);
  }
};

export default encryptPrivateKey;
